/**
 * Menu content component.
 *
 * Styled wrapper for menu content with card styling.
 */

import type { CSSProperties, ReactNode } from "react";
import * as stylex from "@stylexjs/stylex";
import * as BloomMenu from "bloom-menu";

import { styles } from "./menu-styles.stylex";

export interface MenuContentProps {
  children: ReactNode;
  style?: CSSProperties;
}

export function MenuContent({ children, style }: MenuContentProps) {
  return (
    <BloomMenu.Content
      style={{
        backgroundColor: "var(--primaris-card)",
        border: "1px solid var(--primaris-border)",
        borderRadius: 12,
        ...stylex.props(styles.content).style,
        ...style,
      }}
    >
      {children}
    </BloomMenu.Content>
  );
}
